module.exports = __webpack_public_path__ + "img/gold-00.bf6cea83.png";